module.exports = __webpack_public_path__ + "img/parteight_pic2.d7b8cb2e.png";